(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('templates/roleForm.tpl.html', [
'<!--',
'',
' * Copyright (C) 2009-2025 by the geOrchestra PSC',
' *',
' * This file is part of geOrchestra.',
' *',
' * geOrchestra is free software: you can redistribute it and/or modify it under',
' * the terms of the GNU General Public License as published by the Free',
' * Software Foundation, either version 3 of the License, or (at your option)',
' * any later version.',
' *',
' * geOrchestra is distributed in the hope that it will be useful, but WITHOUT',
' * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or',
' * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for',
' * more details.',
' *',
' * You should have received a copy of the GNU General Public License along with',
' * geOrchestra.  If not, see <http://www.gnu.org/licenses/>.',
' ',
'-->',
'',
'<form class="form-horizontal">',
'',
'  <div ng-if="!model">pas de model</div>',
'',
'  <div class="row role-form">',
'',
'    <div class="col-md-12">',
'',
'',
'      <div class="form-group form-group-sm required">',
'        <label class="col-sm-4" for="cn" translate>role.cn</label>',
'        <div class="col-sm-8">',
'          <input ng-model="model.cn" class="form-control" id="cn"',
'            placeholder="" ng-required="true" ng-readonly="isProtectedRole(model)" shortname>',
'           <p class="help-block" translate>role.helpFormat</p>',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm">',
'        <label class="col-sm-4" for="newRoleDesc" translate>role.description</label>',
'        <div class="col-sm-8">',
'          <textarea ng-model="model.description" class="form-control" id="newRoleDesc"',
'                    ng-readonly="isProtectedRole(model)"',
'                    placeholder=""></textarea>',
'        </div>',
'      </div>',
'',
'      <div class="form-group form-group-sm" ng-if="!isProtectedRole(model)">',
'        <label class="col-sm-4" for="favorite" translate>role.favorite</label>',
'        <div class="col-sm-8">',
'          <input type="checkbox" ng-model="model.isFavorite" id="favorite">',
'        </div>',
'      </div>',
'',
'    </div>',
'',
'  </div>',
'',
'</form>',
'',''].join("\n"));
  }]);
})();